import { Link, Text, Tooltip } from '@nimbus-ds/components';
import { AbandonedCartsResponseDto } from '@tiendanube/common';
import { useNavegate } from 'App/hooks';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface AbandonedCartsListCustomerNameProps {
  abandonedCart: AbandonedCartsResponseDto;
  isMobile?: boolean;
}

function AbandonedCartsListCustomerName({
  abandonedCart,
  isMobile = false,
}: AbandonedCartsListCustomerNameProps) {
  const { goTo } = useNavegate();
  const goToCustomer = () => {
    goTo(`/customers/${abandonedCart.customer.id}`);
  };
  const t = useTranslationOrders();

  function CustomerName() {
    return abandonedCart.customer.id ? (
      <Link
        as={isMobile ? 'a' : 'button'}
        appearance="primary"
        onClick={goToCustomer}
        textDecoration="none"
      >
        {abandonedCart.customer.name}
      </Link>
    ) : (
      <Text>{abandonedCart.customer.name}</Text>
    );
  }

  return abandonedCart.customer.name ? (
    <CustomerName />
  ) : (
    <Tooltip
      content={t('abandonedCarts.tooltip.customerNameNotAvailable')}
      position="right"
    >
      <Text color="neutral-textDisabled">
        {t('abandonedCarts.table.body.notAvailable')}
      </Text>
    </Tooltip>
  );
}

export default AbandonedCartsListCustomerName;
